<template>
  <div style="width: 100%; height: 100%">
    <a-layout id="components-layout-demo-custom-trigger">
      <a-layout-sider
        v-model="collapsed"
        :trigger="null"
        collapsible
        breakpoint="xl"
        @breakpoint="changesize"
        :width="200"
      >
        <!-- <a-menu class="bigLogo" :selectable="false">
        <a-menu-item class="logo">
          <img src="http://www.conch.cn/uploadfiles/2019/03/20190328124036953.png?bG9nby5wbmc=" alt="" style="height:28px">
          <span class="logotitle">平台管理</span>
        </a-menu-item>
      </a-menu> -->
        <div class="logo">
          <img src="@assets/imgs/logoWhite.png" alt="" style="height: 45px" />
          <!-- <img src="@assets/imgs/logo.svg" alt="" style="height: 32px" /> -->
          <!-- <span class="logotitle" v-show="!collapsed"> 云训练平台 </span> -->
          <!-- <span class="logotitle" v-show="!collapsed"> 智能工业质检平台 </span> -->
        </div>
        <!-- <div class="people">
          
              <a-avatar style="color:red" :size="45" icon="user" />
              <div>
                <span style="margin-left: 8px;font-size:18px"> {{ userName }} </span>
                <div class="status-people">
                  <div class="green">

                </div>
                <span> 在线 </span>
                </div>
                
              </div>
              
            
        </div> -->
        <!-- <div style="height:30px">

        </div> -->
        <a-menu
          theme="dark"
          mode="inline"
          v-if="isUser"
          :defaultOpenKeys="[this.$route.matched[1].path]"
          :default-selected-keys="['/train/task-list']"
          :selectedKeys="[this.$route.path]"
          @click="
            ({ key }) => {
              this.$router.push(key);
            }
          "
        >
          <!-- <a-menu-item id="big" key="/train/project-list">
            <a-icon style="font-size:40px" type="project" />
            <span style="transform: translateX(-15%);">项目管理</span>
          </a-menu-item> -->
          <a-menu-item id="big" v-for="menu in menuList" :key="menu.path">
            <a-icon style="font-size: 40px" :type="menu.icon" />
            <span style="transform: translateX(-15%)">{{ menu.name }}</span>
          </a-menu-item>
          <!-- <a-menu-item key="/train/ErrorLog">
        <a-icon type="file-excel" />
        <span>错误日志</span>
      </a-menu-item> -->
        </a-menu>

        <a-menu
          theme="dark"
          mode="inline"
          v-if="!isUser"
          :defaultOpenKeys="[this.$route.matched[1].path]"
          :default-selected-keys="['/train/task-list']"
          :selectedKeys="[this.$route.path]"
          @click="
            ({ key }) => {
              this.$router.push(key);
            }
          "
        >
          <a-menu-item key="/train/project-list">
            <a-icon type="project" />
            <span>项目管理</span>
          </a-menu-item>
          <template v-for="(menu, i) in menuList">
            <a-sub-menu :key="i" v-if="!!menu.children">
              <span slot="title"
                ><a-icon :type="menu.icon" />
                <span>{{ menu.name }}</span>
              </span>
              <a-menu-item
                :key="minroute.path"
                v-for="minroute in menu.children"
              >
                {{ minroute.name }}
              </a-menu-item>
            </a-sub-menu>
            <a-menu-item :key="menu.path" v-else>
              <a-icon :type="menu.icon" />
              <span>{{ menu.name }}</span>
            </a-menu-item>
          </template>

          <!-- <a-menu-item key="/train/ErrorLog">
        <a-icon type="file-excel" />
        <span>错误日志</span>
      </a-menu-item> -->
        </a-menu>
      </a-layout-sider>
      <a-layout>
        <div class="title-bar" v-if="$isEE">
          <div class="drag-region"></div>
          <a-layout-header
            style="
              background: #001529;
              padding: 0;
              z-index: 1111;

              box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            "
          >
            <div class="head-left">
              <i class="headLeftTitle">KVIS-CLOUD</i>
              <i style="font-weight: 700">训练子系统</i>
            </div>

            <!-- <a-icon
            class="trigger"
            :type="collapsed ? 'menu-unfold' : 'menu-fold'"
            @click="() => (collapsed = !collapsed)"
          /> -->
            <div class="controls">
              <a-icon type="minus" @click="minimizeWindow" />
              <a-icon type="border" @click="maximizeOrRestoreWindow" />
              <a-icon type="close" @click="closeWindow" />
            </div>
            <a-dropdown
              class="helpDropdown"
              style="-webkit-app-region: no-drag; margin-right: 0"
            >
              <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                <a-icon style="font-size: 30px" type="question-circle" />
                <!-- <span style="margin-left:4px"> {{ userName }} </span> -->
                <span class="helpFont">帮助</span>
              </a>
              <a-menu slot="overlay">
                <!-- <a-menu-item> 使用说明 </a-menu-item> -->
                <a-menu-item @click="useFTPtool">
                  软件工具下载中心
                </a-menu-item>
              </a-menu>
            </a-dropdown>
            <a-icon
              style="
                z-index: 1111;
                position: relative;
                -webkit-app-region: no-drag;
              "
              @click="showModal"
              title="退出登录"
              type="poweroff"
              class="poweroff"
            >
            </a-icon>
            <div class="slash"></div>
            <div
              class="person"
              style="margin-right: 0; -webkit-app-region: no-drag"
            >
              <a-dropdown class="helpDropdown">
                <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                  <a-avatar class="personAvatar" :size="45" icon="user" />
                  <span style="margin-left: 8px; font-size: 18px; color: white">
                    {{ userName }}
                  </span>
                </a>
                <a-menu slot="overlay">
                  <a-menu-item @click="editPassword"> 修改密码 </a-menu-item>
                </a-menu>
              </a-dropdown>

              <a-modal
                v-if="editPwdShow"
                title="修改密码"
                :visible="editPwdShow"
                :confirm-loading="confirmLoading"
                ok-text="确认"
                cancel-text="取消"
                @ok="pwdHandleOk"
                @cancel="pwdHandleCancel"
              >
                <a-form-model
                  ref="ruleForm"
                  layout="inline"
                  :model="formInline"
                  width="500px"
                  :rules="rules"
                  labelAlign="right"
                  :label-col="{ span: 6 }"
                  :wrapper-col="{ span: 18 }"
                  @submit="handleSubmit"
                  @submit.native.prevent
                >
                  <a-form-model-item label="原密码" prop="oldPwd">
                    <a-input-password
                      v-model.trim="formInline.oldPwd"
                      placeholder="输入旧密码"
                    />
                  </a-form-model-item>
                  <a-form-model-item label="新密码" prop="newPwd">
                    <a-input-password
                      v-model.trim="formInline.newPwd"
                      placeholder="输入新密码"
                    />
                  </a-form-model-item>
                  <a-form-model-item label="确认密码" prop="againNewPwd">
                    <a-input-password
                      v-model.trim="formInline.againNewPwd"
                      placeholder="确认密码"
                    />
                  </a-form-model-item>
                </a-form-model>
              </a-modal>

              <!-- <div class="personMSG">
              <span style="margin-left: 8px; font-size: 18px; color: white">
                {{ userName }}
              </span>
              <div class="status-people"></div>
            </div> -->
            </div>
          </a-layout-header>
        </div>
        <a-layout-header
          v-else
          style="
            background: #001529;
            padding: 0;
            z-index: 99;

            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
          "
        >
          <div class="head-left">
            <i class="headLeftTitle">KVIS-CLOUD</i>
            <i style="font-weight: 700">训练子系统</i>
          </div>

          <!-- <a-icon
            class="trigger"
            :type="collapsed ? 'menu-unfold' : 'menu-fold'"
            @click="() => (collapsed = !collapsed)"
          /> -->
          <a-dropdown class="helpDropdown">
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              <a-icon style="font-size: 30px" type="question-circle" />
              <!-- <span style="margin-left:4px"> {{ userName }} </span> -->
              <span class="helpFont">帮助</span>
            </a>
            <a-menu slot="overlay">
              <!-- <a-menu-item> 使用说明 </a-menu-item> -->
              <a-menu-item @click="useFTPtool">软件工具下载中心 </a-menu-item>
            </a-menu>
          </a-dropdown>
          <a-icon
            style="z-index: 1111; position: relative"
            @click="showModal"
            title="退出登录"
            type="poweroff"
            class="poweroff"
          >
          </a-icon>
          <div class="slash"></div>
          <div class="person" style="margin-right: 0">
            <a-dropdown class="helpDropdown">
              <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                <a-avatar class="personAvatar" :size="45" icon="user" />
                <span style="margin-left: 8px; font-size: 18px; color: white">
                  {{ userName }}
                </span>
              </a>
              <a-menu slot="overlay">
                <a-menu-item @click="editPassword"> 修改密码 </a-menu-item>
              </a-menu>
            </a-dropdown>

            <a-modal
              v-if="editPwdShow"
              title="修改密码"
              :visible="editPwdShow"
              :confirm-loading="confirmLoading"
              ok-text="确认"
              cancel-text="取消"
              @ok="pwdHandleOk"
              @cancel="pwdHandleCancel"
            >
              <a-form-model
                ref="ruleForm"
                layout="inline"
                :model="formInline"
                width="500px"
                :rules="rules"
                labelAlign="right"
                :label-col="{ span: 6 }"
                :wrapper-col="{ span: 18 }"
                @submit="handleSubmit"
                @submit.native.prevent
              >
                <a-form-model-item label="原密码" prop="oldPwd">
                  <a-input-password
                    v-model.trim="formInline.oldPwd"
                    placeholder="输入旧密码"
                  />
                </a-form-model-item>
                <a-form-model-item label="新密码" prop="newPwd">
                  <a-input-password
                    v-model.trim="formInline.newPwd"
                    placeholder="输入新密码"
                  />
                </a-form-model-item>
                <a-form-model-item label="确认密码" prop="againNewPwd">
                  <a-input-password
                    v-model.trim="formInline.againNewPwd"
                    placeholder="确认密码"
                  />
                </a-form-model-item>
              </a-form-model>
            </a-modal>

            <!-- <div class="personMSG">
              <span style="margin-left: 8px; font-size: 18px; color: white">
                {{ userName }}
              </span>
              <div class="status-people"></div>
            </div> -->
          </div>
        </a-layout-header>
        <a-spin size="large" :spinning="$store.state.isSpinning">
          <a-layout-content
            :style="{
              margin: '5px 0 0 0',
              padding: '24px 24px 0 24px',
              background: '#fff',
              minHeight: '92.7vh',
            }"
          >
            <!-- <transition name="transitionLeft" mode="out-in"> -->

            <router-view class="transitionBody" />

            <!-- </transition> -->
          </a-layout-content>
        </a-spin>
        <!-- <a-layout-footer style="text-align: center;padding: 10px 50px">
          <span>Copyright ©2018 科亿科技</span>
          <br />
          <span style="color: red">安徽省科亿信息科技有限公司</span>
        </a-layout-footer> -->
      </a-layout>
      <a-modal
        title="退出提醒"
        :visible="visible"
        :confirm-loading="confirmLoading"
        ok-text="确认"
        cancel-text="取消"
        @ok="handleOk"
        @cancel="handleCancel"
      >
        <p>{{ ModalText }}</p>
      </a-modal>
      <!-- <a-modal
    :visible="WarnVisible"
    ok-text="确认"
    cancel-text="取消"
    @ok="warnOk"
    @cancel="warnCancel"
    >
    fafafag
    </a-modal> -->
    </a-layout>
    <!-- <div class="mask" v-show="iswarn">
      <div class="warn">
        <div class="warnTitle">温馨提示</div>
        <div class="warnContent">
          亲爱的用户:缺陷模型算法(瓶子瓶盖算法)已更新。首次训练建议将训练次数参数定为200。
        </div>
        <div class="warnFoot">
          <a-button size="large" type="primary" @click="warnOk">
            知道了
          </a-button>
        </div>
      </div>
    </div> -->
    <div class="mask" v-show="iswarn">
      <div class="warn">
        <div class="warnTitle">平台升级迁移说明函</div>
        <div class="warnContent">
          <h3>尊敬的用户</h3>
          <p>
            感谢您对我司产品的支持和信任。为了确保您在使用训练平台获得最新的功能和更好的服务体验，我们计划进行平台的升级迁移。在此，我们向您说明升级的相关事宜，并希望得到您的配合和支持。
          </p>
          <h4>一、升级迁移的背景和目的</h4>
          <p>
            随着我司业务快速发展和用户对视觉检测要求越来越高，为了满足市场需求和提升用户体验，我们决定对系统进行升级迁移。升级迁移的目标是为了优化系统的性能和功能，提高系统的稳定性和安全性，以及更好的满足用户的需求。
          </p>
          <h4>二、迁移内容</h4>
          <p>
            1.我们已经开放新平台服务，地址：<a
              href="https://cloud.keyetech.com/home/train"
              target="_blank"
              >https://cloud.keyetech.com/home/train</a
            >。
          </p>
          <p>
            2.新平台账号请联系我司售后或市场销售人员进行开通并关联旧平台账号。
          </p>
          <h4>三、迁移计划</h4>
          <p>
            我们会给您充分的时间去适应使用新平台，在此之前该版平台将正常提供服务。
          </p>
          <h4>四、迁移后的影响</h4>
          <p>
            完成升级迁移后，该版平台会择机关闭训练、仿真测试服务外，其它功能都将永久提供正常服务，同时也提供工具将您的数据从该版平台迁移到新平台中。您不必担心因为平台迁移导致数据丢失的问题。
          </p>
          <p>祝您工作顺利，生活愉快</p>
          <p>此致</p>
        </div>
        <div class="warnFoot">
          <a-button size="large" type="primary" @click="warnOk">
            知道了
          </a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ipcApiRoute from "@/utils/bridge";
import { editPwd } from "../../api/userManagement";
import setrem from "../../utils/setRem";
import { setCookie, getCookie } from "../../utils/cookie";
import { requestUrl } from "../../utils/request_url.js";
export default {
  data() {
    return {
      formInline: {
        oldPwd: "",
        newPwd: "",
        againNewPwd: "",
      },
      rules: {
        oldPwd: [{ required: true, message: "请输入您的原始密码" }],
        newPwd: [{ required: true, message: "请输入您的新密码" }],
        againNewPwd: [{ required: true, message: "请输入确认密码" }],
      },
      editPwdShow: false,
      WarnVisible: true,
      // username: localStorage.getItem('username')?JSON.parse(localStorage.getItem('username')):'name',
      userType: null,
      isUser: false,
      collapsed: false,
      iswarn: false,
      routes: [],
      ModalText: "您确认退出嘛?",
      visible: false,
      confirmLoading: false,
      router: [this.$route.path],
      menuList: [],
      userName: "",
      sidersize: 200,
      menuList1: [
        {
          path: "/train/trainManage",
          name: "训练管理",
          icon: "folder",
          children: [
            {
              path: "/train/trainManage/project-resources",
              name: "资源管理",
            },
            {
              path: "/train/trainManage/task-list",
              name: "任务管理",
            },
          ],
        },
        {
          path: "/train/test",
          name: "测试管理",
          icon: "security-scan",
          children: [
            {
              path: "/train/test/TestResourceManage",
              name: "资源管理",
            },
            {
              path: "/train/test/TestMissionManage",
              name: "任务管理",
            },
          ],
        },
        {
          path: "/train/transform",
          name: "模型转换",
          icon: "cloud-sync",
          component: () => import("@views/Transform"),
        },
        {
          path: "/train/semiLearn",
          name: "半监督学习",
          icon: "build",
          children: [
            {
              path: "/train/semiLearn/SemiResourceManage",
              name: "资源管理",
            },
            {
              path: "/train/semiLearn/SemiMissionManage",
              name: "任务管理",
            },
          ],
        },
        {
          path: "/train/system",
          name: "系统管理",
          icon: "setting",
          children: [
            {
              path: "/train/system/user-list",
              name: "用户管理",
            },
            {
              path: "/train/system/enterprise-list",
              name: "企业管理",
            },
          ],
        },
      ],
      menuList2: [
        {
          path: "/train",
          name: "训练管理",
          icon: "radar-chart",
          children: [
            {
              path: "/train/trainManage/project-resources",
              name: "资源管理",
            },
            {
              path: "/train/trainManage/task-list",
              name: "任务管理",
            },
          ],
        },
        {
          path: "/train/transform",
          name: "模型转换",
          icon: "cloud-sync",
          component: () => import("@views/Transform"),
        },
      ],
      menuList3: [
        {
          path: "/train/trainManage",
          name: "训练管理",
          icon: "folder",
          children: [
            {
              path: "/train/trainManage/project-resources",
              name: "资源管理",
            },
            {
              path: "/train/trainManage/task-list",
              name: "任务管理",
            },
          ],
        },
        {
          path: "/train/transform",
          name: "模型转换",
          icon: "cloud-sync",
          component: () => import("@views/Transform"),
        },
        {
          path: "/train/test",
          name: "测试管理",
          icon: "security-scan",
          children: [
            {
              path: "/train/test/TestResourceManage",
              name: "资源管理",
            },
            {
              path: "/train/test/TestMissionManage",
              name: "任务管理",
            },
          ],
        },
      ],
      menuList4: [
        {
          path: "/train/trainManage",
          name: "训练管理",
          icon: "folder",
          children: [
            {
              path: "/train/trainManage/project-resources",
              name: "资源管理",
            },
            {
              path: "/train/trainManage/task-list",
              name: "任务管理",
            },
          ],
        },
        {
          path: "/train/test",
          name: "测试管理",
          icon: "security-scan",
          children: [
            {
              path: "/train/test/TestResourceManage",
              name: "资源管理",
            },
            {
              path: "/train/test/TestMissionManage",
              name: "任务管理",
            },
          ],
        },
        {
          path: "/train/transform",
          name: "模型转换",
          icon: "cloud-sync",
          component: () => import("@views/Transform"),
        },
        // {
        //   path: "/train/semiLearn",
        //   name: "半监督学习",
        //   icon: "build",
        //   children: [
        //     {
        //       path: "/train/semiLearn/SemiResourceManage",
        //       name: "资源管理",
        //     },
        //     {
        //       path: "/train/semiLearn/SemiMissionManage",
        //       name: "任务管理",
        //     },
        //   ],
        // },
      ],
    };
  },
  methods: {
    minimizeWindow() {
      this.$ipc.invoke(ipcApiRoute.handlerMinimize);
    },
    maximizeOrRestoreWindow() {
      this.$ipc.invoke(ipcApiRoute.handlerMaximize);
    },
    closeWindow() {
      this.$ipc.invoke(ipcApiRoute.handlerClose);
    },
    handleSubmit() {},
    editPassword() {
      this.editPwdShow = true;
    },
    async pwdHandleOk(e) {
      console.log(e);
      console.log(this.formInline);
      if (
        this.formInline.oldPwd === "" ||
        this.formInline.newPwd === "" ||
        this.formInline.againNewPwd === ""
      )
        return this.$message.error("请输入必填项");
      if (
        this.formInline.oldPwd === this.formInline.newPwd &&
        this.formInline.oldPwd === this.formInline.againNewPwd
      )
        return this.$message.error("新密码与旧密码一致");
      if (this.formInline.newPwd === this.formInline.againNewPwd) {
        let res = await editPwd(this.formInline);
        console.log(res);
        this.$message.success("修改成功，请重新登录");
        localStorage.removeItem("ACCESS_TOKEN");
        this.$router.replace("/login");
      } else {
        this.$message.error("两次密码输入不一致");
      }
    },
    pwdHandleCancel(e) {
      console.log(e);

      this.formInline = {
        oldPwd: "",
        newPwd: "",
        againNewPwd: "",
      };
      this.editPwdShow = false;
    },
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      localStorage.removeItem("ACCESS_TOKEN");
      this.$router.replace("/login");
    },
    warnOk() {
      this.iswarn = false;
      setCookie("warn", "true", 0.5);
    },
    // warnCancel() {
    //   this.WarnVisible = false
    // },
    warning() {
      this.$warning({
        title: "更新提示",
        content: "some messages...some messages...",
      });
    },
    handleCancel(e) {
      this.visible = false;
    },
    chooseMenuList() {
      if (this.userType == 1) {
        this.menuList = this.menuList1;
        this.isUser = false;
      } else {
        console.log(localStorage.getItem("user_id"));
        if (
          localStorage.getItem("user_id") === "1e18f0a07b6647a692c8a9a4b29dd875"
        ) {
          this.menuList = this.menuList4;
          this.isUser = false;
        } else {
          this.menuList = this.menuList3;
          this.isUser = false;
        }
      }
    },
    useFTPtool() {
      window.open("http://183.162.251.135:18080/software-service", "_blank");
    },
    changesize(value) {
      // if(value){
      //   this.sidersize = 100
      // }else{
      //    this.sidersize = 200
      // }
    },
  },
  computed: {
    // username(){
    //   return this.$store.state.username
    // }
  },
  created() {
    // this.routes = this.$router.options.routes[1].children;
    // console.log(this.routes);
    // console.log(this);
  },
  mounted() {
    var userType = localStorage.getItem("user_type");
    this.userType = userType;
    var userName = localStorage.getItem("user_name");
    this.userName = userName;
    this.chooseMenuList();
    setrem();
    var warnCookie = getCookie("warn");
    if (warnCookie) {
      this.iswarn = false;
    } else {
      this.iswarn = true;
    }
    // window.onresize = function () {
    //   setrem();
    // };
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
::v-deep .ant-form-item {
  width: 400px;
}
.title-bar {
  position: relative;
  -webkit-app-region: drag;
}

.drag-region {
  -webkit-app-region: drag;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.ant-layout-header {
  position: relative;
}
.controls {
  -webkit-app-region: no-drag;
  float: right;
  display: flex;
  align-items: center;
  height: 100%;
  padding-right: 20px;
  > * {
    color: red;
    font-size: 20px;
    margin-left: 30px;
    &:hover {
      color: #fff;
    }
  }
}
</style>
